import React from "react";

interface CriterionSearchInputProps {
	isVisible: boolean;
	criterionKey: string;
	dropdownIsOpened: boolean;
	isMobile: boolean;
	onInputChange: React.ReactEventHandler<HTMLInputElement>;
	value?: string;
}

export default function CriterionSearchInput({
	isVisible,
	value,
	criterionKey,
	dropdownIsOpened,
	isMobile,
	onInputChange,
}: CriterionSearchInputProps) {
	const ref = React.useCallback(
		(input) => !isMobile && input?.focus(),
		[dropdownIsOpened],
	);

	if (!isVisible) {
		return null;
	}

	return (
		<div className={`form-group`}>
			<label htmlFor={`search-within-${criterionKey}`}>
				Search within
			</label>
			<input
				ref={ref}
				type="text"
				name={`search-within-${criterionKey}`}
				value={value}
				id={`search-within-${criterionKey}`}
				placeholder="Search"
				autoComplete="off"
				onChange={onInputChange}
			/>
		</div>
	);
}
